module.exports = __webpack_public_path__ + "static/media/pixel.f2a86377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/pixel.png
// module id = 60
// module chunks = 0